<script setup>
const props = defineProps({
  loading: {
    default: false,
    type: Boolean
  },
  asContent: {
    default: false,
    type: Boolean
  },
  // Add class prop to handle class binding
  class: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div v-if="props.loading">
    Loading...
  </div>
  <div
    v-else-if="props.asContent"
    :class="props.class"
  >
    <div
      class="rounded-xl mb-4"
    >
      <!--    Header-->
      <div
        class="relative p-4 rounded-xl shadow-lg"
        style="
          background-image: url('/images/default-header-bg-2.svg');
          background-size: cover;
          background-position: center bottom
        "
      >
        <div class="relative z-10">
          <h4 class="text-green-100 text-left text-base h5 font-semibold drop-shadow-sm">
            <slot name="header-title" />
          </h4>
        </div>
        <span class="absolute rounded-xl top-0 left-0 w-full h-full bg-gray-950/60" />
      </div>

      <!--    Body-->
      <div>
        <slot name="body" />
      </div>

      <!--    Footer -->
      <div>
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
